import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { TrustSection } from './components/TrustSection';
import { PopularProducts } from './components/PopularProducts';
import { ProductCategories } from './components/ProductCategories';
import { AllProducts } from './components/AllProducts';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-sans text-gray-900" data-id="element-0">
      <Header data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <TrustSection data-id="element-4" />
        <PopularProducts data-id="element-5" />
        <ProductCategories data-id="element-6" />
        <AllProducts data-id="element-7" />
      </main>
      <Footer data-id="element-8" />
    </div>;
}